import { ref } from 'vue'

export function createNotesState() {
    function createInitialFilters() {
        return {
            search: null
        }
    }

    return {
        productionSiteNotes: ref([]),
        productionSiteNotesLoading: ref(false),
        unreadProductionSiteNotes: ref(0),
        filters: ref(createInitialFilters()),
        createInitialFilters,
        currentNote: ref(null),
        productionSiteFormSites: ref([])
    }
}
